import { InterfaceMapBox } from 'components/MapboxMap/types'
import React, { useContext, useEffect, useState } from 'react'
import { MapContext } from '../MapboxMap'

import './styles.scss'

interface Props {
  isMobile: boolean
  hazards: { name: string; id: string; color: string }[]
}

export const HazardLayerSwitch = ({ hazards, isMobile }: Props) => {
  const map = useContext(MapContext)
  const [visibleLayers, setVisibleLayers] = useState<string[]>(['cat-base'])
  const [showTooltip, setShowTooltip] = useState(true)

  const toggleHazards = (e: any) => {
    if (!e.nativeEvent.target || !map?.loaded()) return

    setShowTooltip(false)

    const hazard = e.nativeEvent.target.id
    const newVisibleLayers = [hazard] // visibleLayers.filter(h => h !== hazard)

    // if (
    //   newVisibleLayers.length === visibleLayers.length ||
    //   visibleLayers.length === 0
    // ) {
    //   newVisibleLayers.push(hazard)
    // }

    setVisibleLayers(newVisibleLayers)
  }

  const showAndHideHazards = () => {
    if (!map) return
    const layers = map.getStyle().layers

    hazards.forEach((hazard: { name: string; id: string; color: string }) => {
      const layer = layers.find(l => l.id === hazard.id)
      if (!layer) return
      if (visibleLayers.includes(hazard.id)) {
        map.setLayoutProperty(layer.id, 'visibility', 'visible')
      } else {
        map.setLayoutProperty(layer.id, 'visibility', 'none')
      }
    })
  }

  // Show and Hide Hazard-Layers
  useEffect(() => {
    if (!map || !map.loaded()) return
    showAndHideHazards()
  }, [visibleLayers])

  return (
    <div className='hazardswitchcontainer'>
      {map && (
        <>
          {showTooltip && (
            <span className='tooltip bottom layers'>
              Cliquez ici pour changer vos préférences
            </span>
          )}
          {hazards.map((h, i) => (
            <button
              key={i}
              id={h.id}
              onClick={toggleHazards}
              style={{
                backgroundColor: h.color
              }}
              className={`hazardswitch ${h.id} 
            ${visibleLayers.includes(h.id) ? '' : 'off'}`}
            >
              <img src={require('images/icons_' + h.id + '.svg')} />
              <div>{h.name}</div>
            </button>
          ))}
        </>
      )}
    </div>
  )
}
